import FieldDatepicker from './FieldDatepicker-redux';

export default FieldDatepicker;
